import {
  getProductWithBrand,
  getProductWithCategory,
  getProductWithSubCategory,
  getUniqueBrands,
  getUniqueCategories,
  getUniqueSubCategories,
} from "../../helpers/product";
import React from "react";
import { setActiveSort } from "../../helpers/product";

const ShopProductBrands = ({
  products,
  getSortParams,
  sideSpaceClass,
  value,
  setSortValues,
  category,
  subcategory,
}) => {
  const uniqueBrands = getUniqueBrands(products)?.sort();
  console.log("uniqueBrands", uniqueBrands);
  return (
    <div className="row g-4">
      {uniqueBrands?.map((brand) => {
        const numArt = getProductWithBrand(
          products,
          category,
          subcategory,
          brand
        );
        if (brand === "" || numArt <= 0) return null;

        return (
          <div
            className={
              "col-12 " + global.aziendaID == 4 ? "col-md-6" : "col-md-2"
            }
            key={brand}
            onClick={(e) => {
              if (document.querySelector("#allBrands"))
                document.querySelector("#allBrands").classList.remove("active");
              if (e.currentTarget.classList.contains("active"))
                getSortParams("brands", brand, "-");
              else getSortParams("brands", brand, "+");
              setActiveSort(e);
            }}
          >
            <div
              className="card text-center shadow-sm border-0"
              style={{ height: "200px" }}
            >
              <div
                className="card-body"
                style={{
                  backgroundImage:
                    "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('" +
                    global.baseUrlImage +
                    "tag/foto marchi/" +
                    category +
                    ".png" +
                    "')",
                  backgroundSize: "cover",
                  backgroundPosition: "center",

                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/*<div className="p-3 bg-primary text-white rounded-circle d-inline-block mb-3">
                  <svg
                    className="bi"
                    width="32"
                    height="32"
                    fill="currentColor"
                  >
                    {/* Puoi aggiungere qui l'icona appropriata 
                  </svg>
                </div>*/}
                {/*<h5 className="card-title">{brand}</h5>
                <p className="card-text text-muted">{numArt} prodotti</p>*/}
                <h3 className="card-title" style={{ color: "white" }}>
                  {brand}
                </h3>
                <h5 className="card-text " style={{ color: "white" }}>
                  {numArt} prodotti
                </h5>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ShopProductBrands;
